import { replaceData } from '../common';

/**
 * Check conditions.
 * @param (Array) conditions
 * @param (Object) userData
 * @return {boolean}
 */
export const checkConditions = (conditions, userData) => {
  if (typeof conditions === 'boolean') {
    return conditions;
  }

  return !conditions || conditions.reduce((result, condition) => {
    if (!result) {
      return result;
    }
    try {
      const cond = replaceData(condition, userData, false, false, true, true);
      // eslint-disable-next-line
      const condResult = eval(cond);
      return result && condResult;
    } catch (e) {
      // eslint-disable-next-line
      console.warn('checkConditions failed:', condition, e);
      return false;
    }
  }, true);
};

/**
 * Validate coverage code.
 * @param  (string) coverageCode
 * @param  (Object) initialValues
 * @param  (Object) userData
 * @return {boolean}
 */
export const validateCoverageCode = (coverage, initialValues, userData) => {
  if (Object.hasOwnProperty.call(coverage, 'conditions')) {
    if (!checkConditions(coverage.conditions, userData)) {
      return false;
    }
  }

  if (Object.hasOwnProperty.call(initialValues, 'coverageList')) {
    const { coverageList } = initialValues;
    if (coverageList[coverage.code] && coverageList[coverage.code].conditions) {
      const { conditions } = coverageList[coverage.code];
      return checkConditions(conditions, userData);
    } else if (!coverageList[coverage.code]) {
      return false;
    }
  }

  return true;
};

/**
 * Set flag on the coverage code.
 * @param Object formParams
 * @param string coverageCode
 * @return {Object}
 */
export const setCoverageCodeFormParams = (formParams, coverageCode) => {
  const newFormParams = formParams;
  newFormParams.values[coverageCode] =
    formParams.values.coverageCodes ?
      formParams.values.coverageCodes.indexOf(coverageCode) !== -1 :
      false;

  return newFormParams;
};

/**
 * Returns an array of packages and the applicable coverages.
 * @param  {object} state   The current state.
 * @return {array}          Array of object containing the packages and
 *                          the applicable coverages.
 */
export const getPackagesWithCoverage = (state) => {
  const { section: { packageData: { initialValues } }, userData } = state;
  const packagesWithCoverage = [];
  if (Object.hasOwnProperty.call(initialValues, 'packages')) {
    initialValues.packages.forEach((element) => {
      if (element.calculatePrice === false) {
        return;
      }

      const coverages = element.coverages.filter(coverage => {
        return validateCoverageCode(coverage, initialValues, userData);
      });

      const removedCoverages = element.coverages.filter(coverage => {
        return coverages.map(e => e.code).indexOf(coverage.code) === -1;
      });

      const newMappedParams = {
        'coverageCodes': coverages.map(e => e.code),
        'packageId': element.id,
        'removedCoverages': removedCoverages.map(e => e.code),
      };
      packagesWithCoverage.push(newMappedParams);
    });
  }

  return packagesWithCoverage;
};



// WEBPACK FOOTER //
// ./src/utilities/package/packageUtils.js